<template>
  <div>
    <h4 class='lib__h4'>{{ $t('common.meter.legend') }} : {{ value.meterId }}</h4>
    <div class='row'>
      <div v-for='(registerInfo, idx) in value.registerInfos' :key='idx' class='col-xs-12'>
        <RegisterBox :isGas='isGas' :readonly='readonly' :value='registerInfo' @input='setIndexValue($event, idx)' />
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import RegisterBox from '@/components/inputs/ProsumerDeclaration/meter-reading/RegisterBox.vue'
import { Meter } from '@/models/prosumer-declaration'

@Component({
  components: {
    RegisterBox,
  },
})
export default class MeterBox extends Vue {
  @Prop({ required: true }) public readonly value!: Meter
  @Prop({ type: Boolean, required: true }) public readonly isGas!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly readonly!: boolean

  public setIndexValue(value: string, idx: number): void {
    if (this.readonly) {
      return
    }

    this.value.registerInfos[idx].value = value
    this.$emit('input', this.value)
  }
}
</script>
